import { AutogenModelTia3plSurveyDetail, AutogenRowTia3plSurveyDetail } from "./autogen/AutogenModelTia3plSurveyDetail";

export class ModelTia3plSurveyDetail extends AutogenModelTia3plSurveyDetail<RowTia3plSurveyDetail> {
	constructor() {
		super(RowTia3plSurveyDetail);
	}
}

export class RowTia3plSurveyDetail extends AutogenRowTia3plSurveyDetail {
}